import styled from "styled-components";

export const ShipmentNote = styled.div`
  margin-top: 20px;
`;

export const ShipmentNoteTitle = styled.div`
  font-size: 13px;
`;
